import React from "react";
import { Modal, Button } from "react-bootstrap";

const ConfirmModal = ({ show, handleClose, handleConfirm }) => {
  return (
    <Modal
      show={show}
      onHide={handleClose}
      backdrop="static"
      centered={false}
      style={{
        zIndex: 1055,
        display: "flex",
        alignItems: "flex-start", // aligns at top
        justifyContent: "center", // centers horizontally
        paddingTop: "60px", // spacing from top
      }}
      dialogClassName=""
    >
      <div
        style={{
          width: "500px",
          backgroundColor: "#ffffff",
          borderRadius: "16px",
          padding: "20px",
          boxShadow: "0 10px 25px rgba(0, 0, 0, 0.08)",
        }}
      >
        <p
          style={{
            marginBottom: "20px",
            font:"popins",
            fontSize: "16px",
            fontWeight: "500",
            color: "#111827",
          }}
        >
          Are you sure you want to delete this note?
        </p>

        <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
          <Button
            variant="light"
            onClick={handleClose}
            style={{
              color: "#eab308",
              padding: "4px 9px",
              borderRadius: "8px",
              fontSize: "12px",
              fontWeight: "400",
              border: "none",
              outline: "none",
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleConfirm}
            style={{
              backgroundColor: "#eab308",
              color: "white",
              padding: "4px 9px",
              borderRadius: "8px",
              fontSize: "12px",
              fontWeight: "400",
              border: "none",
              outline: "none",
            }}
            onMouseOver={(e) => (e.target.style.backgroundColor = "#facc15")}
            onMouseOut={(e) => (e.target.style.backgroundColor = "#eab308")}
          >
            Delete
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmModal;
